import { render, staticRenderFns } from "./appTermsExpired.vue?vue&type=template&id=44a95b50&"
import script from "./appTermsExpired.vue?vue&type=script&lang=js&"
export * from "./appTermsExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/modal.vue').default})
